import React from "react";
import { object, string } from "prop-types";
import { format } from "date-fns";
import { Link } from "@quintype/components";
import truncate from "lodash/truncate";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import ResponsiveSourceImage from "../../atoms/responsive-source-image";
import PlaceholderImage from "../../atoms/placeholder-image";

import { getDescription } from "../../utils";

import "./card-image-type-10.m.css";

const CardImageType10 = ({ story, page = "" }) => {
  const authorDetails = (story.authors && story.authors[0]["name"]) || story["author-name"];
  const publishedAt = format(new Date(story["last-published-at"]), "d MMMM yyyy, hh:mm a");
  const storySubheadline = story.subheadline || getDescription(story);
  const getAuthorId = get(story, ["authors", 0, "id"], story["author-id"]);
  const slug = story["hero-image-s3-key"];
  const storyImageSlug = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${story.slug}`}>
      <div styleName={`wrapper`} className="card-image-type-10">
        {storyImageSlug ? (
          <ResponsiveSourceImage story={story} desktopAspectRation={[16, 9]} mobileAspectRation={[1, 1]} />
        ) : (
          <PlaceholderImage className={"qt-image-dynamic"} story={story} />
        )}
        <div>
          <Headline story={story} headerType={13} headerLevel={2} />
          <div styleName="published-info">
            {page !== "author-page" && (
              <p styleName="author-byline">
                <span>By </span>
                <Link href={`/author/${getAuthorId}`}>{authorDetails}</Link>
              </p>
            )}
            <time styleName="date-time" dateTime={publishedAt}>
              {publishedAt}
            </time>
          </div>
          <div styleName="story-subheadline-wrapper">
            {storySubheadline && (
              <p styleName="subheadline">
                {truncate(storySubheadline, {
                  length: 140
                })}
                {storySubheadline.length > 140 && <span styleName="read-more-link">Read More</span>}
              </p>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CardImageType10;

CardImageType10.propTypes = {
  story: object,
  page: string
};
